import { render } from "./match.vue?vue&type=template&id=524a1e0c&scoped=true"
import script from "./match.vue?vue&type=script&lang=js"
export * from "./match.vue?vue&type=script&lang=js"

import "./match.vue?vue&type=style&index=0&id=524a1e0c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-524a1e0c"]])

export default __exports__